import { useEffect, useRef } from 'react';

import { useOnboardingContext } from '@/contexts/onboardingContext';
import useMixpanel from '@/hooks/useTracking/useMixpanel';

import { Props } from './types';

// this is to allow scrolling to the first error when there are multiple
let hasScrolledToError = false;

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const FieldError = ({ error }: Props) => {
  const mixpanel = useMixpanel();
  const errorRef = useRef(null);
  const context = useOnboardingContext();

  useEffect(() => {
    if (error && errorRef.current && !hasScrolledToError) {
      // block scrolling to another error
      hasScrolledToError = true;

      setTimeout(() => {
        const errorElement = errorRef.current as unknown as HTMLElement;
        if (errorElement) {
          const rect = errorElement.getBoundingClientRect();
          const viewportHeight = window.innerHeight;
          const elementHeight = rect.height;

          const targetY = window.scrollY + rect.top - (viewportHeight - elementHeight) / 2;

          window.scrollTo({
            top: targetY,
            behavior: 'smooth'
          });
        }
      }, 100);

      setTimeout(() => {
        hasScrolledToError = false;
      }, 1000);
    }
  }, [error]);

  useEffect(() => {
    if (!error) {
      hasScrolledToError = false;
    }
  }, [error]);

  if (error?.message) {
    mixpanel.trackError(error.message, undefined, {
      version: context.version,
      feature: 'unified-onboarding'
    });
    return (
      <p ref={errorRef} className="light:text-uniform-red-800 dark:text-uniform-red-500">
        {error.message}
      </p>
    );
  }

  return null;
};

export default FieldError;
